import { render, staticRenderFns } from "./CommissionCreate.vue?vue&type=template&id=f5290d7c&"
import script from "./CommissionCreate.vue?vue&type=script&lang=js&"
export * from "./CommissionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports